<p-toast />

<section class="surface-0 border-round p-5 mb-4 shadow-1 mt-3 sol-manager">
  <!-- Header collassabile -->
  <div
    class="flex align-items-center justify-content-between gap-3 pb-3 border-bottom-1 border-200 cursor-pointer"
    [class.mb-4]="!collapsed()"
    (click)="collapsed.update(v => !v)"
    style="user-select: none;"
    role="button"
    [attr.aria-expanded]="!collapsed()"
  >
    <div class="flex align-items-center gap-3">
      <i class="pi pi-sitemap text-2xl" style="color: #00125b;" aria-hidden="true"></i>
      <h2 class="text-xl font-semibold m-0" style="color: #00125b;">Gestisci Codici SOL</h2>
    </div>
    <div class="flex align-items-center gap-3">
      @if (missingMaster()) {
        <p-tag value="Da compilare" severity="secondary" />
      }
      <i
        class="pi text-xl transition-transform transition-duration-200"
        [class.pi-chevron-down]="collapsed()"
        [class.pi-chevron-up]="!collapsed()"
        style="color: #00125b;"
        aria-hidden="true"
      ></i>
    </div>
  </div>

  <div [hidden]="collapsed()">
    <!-- ── Sezione A: Fiduciario e sedi ─────────────────────────────────────── -->
    <div class="sol-subsection">
      @if (missingMaster()) {
        <div class="sol-hint mb-3" role="status">
          <i class="pi pi-exclamation-triangle" aria-hidden="true"></i>
          <span>
            Il fiduciario deve avere un codice SOL <strong>master</strong> (obbligatorio).
            I codici SOL aggiuntivi sulle sedi sono opzionali.
          </span>
        </div>
      }

      <app-registry-table
        title="Fiduciario e sedi"
        icon="pi-briefcase"
        [columns]="tableAColumns"
        [data]="tableARows()"
        [loading]="loadingSol()"
        [ignoreStatusChecks]="true"
        [rowStyleClass]="rowWarningClass"
        emptyStateTitle="Nessuna sede operativa presente"
        emptyStateMessage="Non ci sono sedi o codici SOL da visualizzare."
        [customActionsTemplate]="solActions"
      >
        <div toolbar-extra class="flex align-items-center gap-2 flex-wrap">
          <!-- Esporta Excel MFA: sempre disponibile quando ci sono codici SOL,
               a prescindere da fase (revisione/attesa/contrattuale) e permessi di gestione. -->
          @if (solCodes().length > 0) {
            <button
              pButton
              type="button"
              label="Esporta Excel MFA"
              icon="pi pi-file-excel"
              class="p-button-outlined"
              (click)="exportMfa.emit()"
            ></button>
          }
          @if (canManage()) {
            @if (mfaReviewMode()) {
              @if (editLocked()) {
                <button
                  pButton
                  type="button"
                  label="Modifica"
                  icon="pi pi-pencil"
                  (click)="requestEditMode()"
                ></button>
              } @else {
                <span
                  class="inline-flex align-items-center gap-1 text-sm font-medium"
                  style="color: #166534;"
                >
                  <i class="pi pi-pencil" aria-hidden="true"></i> Modifica abilitata
                </span>
              }
            }
            <button
              pButton
              type="button"
              label="Aggiungi codice SOL"
              icon="pi pi-plus"
              [class.p-button-outlined]="addBlocked()"
              [pTooltip]="addBlockedTooltip()"
              [attr.aria-disabled]="addBlocked()"
              (click)="onAddClick()"
            ></button>
          }
        </div>
      </app-registry-table>

      <ng-template #solActions let-row>
        @if (row.kind === 'sol') {
          <button
            pButton
            type="button"
            icon="pi pi-eye"
            class="p-button-text p-button-sm"
            pTooltip="Dettaglio"
            (click)="openDetail(row.sol)"
            [attr.aria-label]="'Dettaglio codice ' + row.sol.code"
          ></button>
          @if (canEditNow() && !deleteDisabled(row)) {
            <button
              pButton
              type="button"
              icon="pi pi-trash"
              class="p-button-text p-button-sm p-button-danger"
              pTooltip="Elimina"
              (click)="confirmDelete(row.sol)"
              [attr.aria-label]="'Elimina codice ' + row.sol.code"
            ></button>
          }
        } @else {
          @if (canEditNow()) {
            <button
              pButton
              type="button"
              icon="pi pi-pencil"
              class="p-button-text p-button-sm"
              pTooltip="Inserisci il codice SOL master"
              (click)="openAdd()"
              [attr.aria-label]="'Inserisci il codice SOL master'"
            ></button>
          }
        }
      </ng-template>
    </div>
  </div>
</section>

<!-- ── Dialog Aggiungi / Modifica ───────────────────────────────────────────── -->
<p-dialog
  [header]="dialogTitle()"
  [visible]="showFormDialog()"
  (visibleChange)="showFormDialog.set($event)"
  [modal]="true"
  [dismissableMask]="true"
  appendTo="body"
  [style]="{ width: '520px' }"
  [draggable]="false"
  [resizable]="false"
>
  <div class="sol-form">
    <small class="block text-color-secondary mb-2">
      I campi contrassegnati con <span class="sol-required" aria-hidden="true">*</span> sono obbligatori.
    </small>
    <div class="field field-checkbox sol-form-master">
      <p-checkbox
        inputId="sol-is-master"
        [binary]="true"
        [disabled]="masterLocked()"
        [ngModel]="form().isMaster"
        (ngModelChange)="onMasterChange($event)"
      />
      <label for="sol-is-master" class="mb-0">Codice SOL master del fiduciario</label>
    </div>
    <small class="block text-color-secondary mt-1 mb-3">{{ masterHint() }}</small>

    <div class="field">
      <label for="sol-code">Codice SOL <span class="sol-required" aria-hidden="true">*</span></label>
      <input
        id="sol-code"
        type="text"
        pInputText
        class="w-full"
        [class.p-invalid]="!!codeError()"
        maxlength="5"
        [ngModel]="form().code"
        (ngModelChange)="onCodeInput($event)"
        placeholder="Es. A1B2C"
        [attr.aria-required]="true"
        [attr.aria-invalid]="!!codeError()"
      />
      @if (codeError()) {
        <small class="sol-field-error" role="alert">{{ codeError() }}</small>
      }
    </div>

    <div class="field">
      <label for="sol-denomination">Denominazione <span class="sol-required" aria-hidden="true">*</span></label>
      <input
        id="sol-denomination"
        type="text"
        pInputText
        class="w-full"
        maxlength="255"
        [class.p-invalid]="invalidDenomination()"
        [ngModel]="form().denomination"
        (ngModelChange)="updateForm('denomination', $event)"
        placeholder="Es. ragione sociale + tipo società"
        [attr.aria-required]="true"
        [attr.aria-invalid]="invalidDenomination()"
      />
      @if (invalidDenomination()) {
        <small class="sol-field-error" role="alert">Campo obbligatorio</small>
      } @else {
        <small class="block text-color-secondary mt-1">
          Precompilata dai dati anagrafici, modificabile.
        </small>
      }
    </div>

    <div class="field">
      <label for="sol-category">Categoria <span class="sol-required" aria-hidden="true">*</span></label>
      <input
        id="sol-category"
        type="text"
        pInputText
        class="w-full"
        [class.p-invalid]="invalidCategory()"
        [ngModel]="form().category"
        (ngModelChange)="updateForm('category', $event)"
        [attr.aria-required]="true"
        [attr.aria-invalid]="invalidCategory()"
      />
      @if (invalidCategory()) {
        <small class="sol-field-error" role="alert">Campo obbligatorio</small>
      }
    </div>

    <div class="field field-checkbox sol-form-physical">
      <p-checkbox
        inputId="sol-physical-site"
        [binary]="true"
        [ngModel]="form().physicalSite"
        (ngModelChange)="onPhysicalSiteChange($event)"
      />
      <label for="sol-physical-site" class="mb-0">SOL su sede fisica</label>
    </div>
    <small class="block text-color-secondary mt-1 mb-3">
      Disattiva se il codice SOL opera su territorio: indica Regione e Provincia di competenza.
    </small>

    @if (form().physicalSite) {
      <div class="field">
        <label for="sol-site">Sede operativa <span class="sol-required" aria-hidden="true">*</span></label>
        <p-select
          id="sol-site"
          [options]="siteOptions()"
          optionLabel="label"
          optionValue="value"
          [filter]="true"
          filterBy="label"
          [class.p-invalid]="invalidSite()"
          [ngModel]="targetSiteId()"
          (ngModelChange)="targetSiteId.set($event)"
          placeholder="Seleziona la sede operativa"
          [attr.aria-required]="true"
          [attr.aria-invalid]="invalidSite()"
          [style]="{ width: '100%' }"
          [showClear]="true"
        ></p-select>
        @if (invalidSite()) {
          <small class="sol-field-error" role="alert">Campo obbligatorio</small>
        } @else {
          <small class="block text-color-secondary mt-1">
            Scegli la sede fisica a cui è associato il codice SOL.
          </small>
        }
      </div>
    }

    @if (!form().physicalSite) {
      <div class="field">
        <label for="sol-region">Regione <span class="sol-required" aria-hidden="true">*</span></label>
        <p-select
          id="sol-region"
          [options]="regionOptions()"
          optionLabel="label"
          optionValue="value"
          [filter]="true"
          filterBy="label"
          [class.p-invalid]="invalidRegion()"
          [ngModel]="form().region"
          (ngModelChange)="onRegionChange($event)"
          placeholder="Seleziona regione"
          [attr.aria-required]="true"
          [attr.aria-invalid]="invalidRegion()"
          [style]="{ width: '100%' }"
          [showClear]="true"
        />
        @if (invalidRegion()) {
          <small class="sol-field-error" role="alert">Campo obbligatorio</small>
        }
      </div>

      <div class="field">
        <label for="sol-province">Provincia <span class="sol-required" aria-hidden="true">*</span></label>
        <p-select
          id="sol-province"
          [options]="provinceOptions()"
          optionLabel="label"
          optionValue="value"
          [filter]="true"
          filterBy="label"
          [disabled]="!form().region || loadingProvinces()"
          [class.p-invalid]="invalidProvince()"
          [ngModel]="form().province"
          (ngModelChange)="updateForm('province', $event)"
          [placeholder]="!form().region ? 'Seleziona prima la regione' : (loadingProvinces() ? 'Caricamento…' : 'Seleziona provincia')"
          [attr.aria-required]="true"
          [attr.aria-invalid]="invalidProvince()"
          [style]="{ width: '100%' }"
          [showClear]="true"
        />
        @if (invalidProvince()) {
          <small class="sol-field-error" role="alert">Campo obbligatorio</small>
        }
      </div>

      <div class="field">
        <label for="sol-associated-site">Sede fisica associata <span class="sol-required" aria-hidden="true">*</span></label>
        <p-select
          id="sol-associated-site"
          [options]="siteOptions()"
          optionLabel="label"
          optionValue="value"
          [filter]="true"
          filterBy="label"
          [class.p-invalid]="invalidSite()"
          [ngModel]="targetSiteId()"
          (ngModelChange)="targetSiteId.set($event)"
          placeholder="Seleziona la sede fisica associata"
          [attr.aria-required]="true"
          [attr.aria-invalid]="invalidSite()"
          [style]="{ width: '100%' }"
          [showClear]="true"
        ></p-select>
        @if (invalidSite()) {
          <small class="sol-field-error" role="alert">Campo obbligatorio</small>
        } @else {
          <small class="block text-color-secondary mt-1">
            Precompilata con la sede legale, modificabile. Serve come riferimento fisico per l'estrazione.
          </small>
        }
      </div>
    }

    <div class="sol-form-section">
      <div class="sol-form-section__title">Gerarchia</div>

      <div class="field">
        <label for="sol-hierarchy">Gerarchia &ndash; Codice SOL</label>
        <input
          id="sol-hierarchy"
          type="text"
          pInputText
          class="w-full"
          maxlength="5"
          [disabled]="true"
          [ngModel]="form().hierarchyParentCode"
          placeholder="Coincide con il codice SOL master"
        />
        <small class="block text-color-secondary mt-1">
          La gerarchia coincide sempre con il codice SOL master e non è modificabile.
        </small>
      </div>

      @if (showSuffix()) {
        <div class="field">
          <label for="sol-suffix">Gerarchia &ndash; Suffisso <span class="sol-required" aria-hidden="true">*</span></label>
          <p-select
            id="sol-suffix"
            [options]="suffixOptions()"
            optionLabel="label"
            optionValue="value"
            [class.p-invalid]="invalidSuffix()"
            [ngModel]="form().hierarchySuffix"
            (ngModelChange)="updateForm('hierarchySuffix', $event)"
            placeholder="Seleziona suffisso"
            [attr.aria-required]="true"
            [attr.aria-invalid]="invalidSuffix()"
            [style]="{ width: '100%' }"
            [showClear]="true"
          />
          @if (invalidSuffix()) {
            <small class="sol-field-error" role="alert">Campo obbligatorio</small>
          }
        </div>
      }
    </div>

    <div class="field">
      <label for="sol-description">Descrizione</label>
      <textarea
        id="sol-description"
        pTextarea
        rows="2"
        class="w-full"
        [ngModel]="form().description"
        (ngModelChange)="updateForm('description', $event)"
      ></textarea>
    </div>
  </div>

  <ng-template pTemplate="footer">
    <button pButton type="button" label="Annulla" class="p-button-outlined mr-auto" (click)="showFormDialog.set(false)"></button>
    <button pButton type="button" label="Salva" icon="pi pi-check" [loading]="saving()" (click)="save()"></button>
  </ng-template>
</p-dialog>

<!-- ── Dialog dettaglio codice SOL (occhio) ─────────────────────────────────── -->
<p-dialog
  header="Dettaglio codice SOL"
  [visible]="showDetailDialog()"
  (visibleChange)="showDetailDialog.set($event)"
  [modal]="true"
  [dismissableMask]="true"
  appendTo="body"
  styleClass="sol-detail-dialog"
  [style]="{ width: '780px' }"
  [breakpoints]="{ '960px': '92vw' }"
  [draggable]="false"
  [resizable]="false"
>
  @if (selectedSol(); as sol) {
    <div class="sol-detail-modal">
      <!-- Intestazione: codice + stato -->
      <div class="sol-detail-modal__head">
        <div class="sol-detail-modal__code">
          <i class="pi pi-sitemap" aria-hidden="true"></i>
          <span class="code">Codice SOL {{ sol.code || '—' }}</span>
          @if (sol.master) { <p-tag value="Master" severity="info" /> }
        </div>
        <p-tag [value]="statusLabel(sol.status)" [severity]="statusSeverity(sol.status)" />
      </div>

      <!-- Blocco 1: dati del codice SOL definiti dal Back Office -->
      <section class="sol-detail-block">
        <h4 class="sol-detail-block__title">
          <i class="pi pi-briefcase" aria-hidden="true"></i>
          Dati del codice SOL
        </h4>
        <div class="sol-detail-grid">
          <div class="sol-detail-item">
            <span class="k">Denominazione</span>
            <span class="v">{{ sol.denomination || '—' }}</span>
          </div>
          <div class="sol-detail-item">
            <span class="k">Categoria</span>
            <span class="v">{{ sol.category || '—' }}</span>
          </div>
          <div class="sol-detail-item sol-detail-item--full">
            <span class="k">Riferimento sede/territorio</span>
            <span class="v">
              @if (sol.physicalSite) {
                {{ solSiteAddress(sol) }}
              } @else {
                Territorio: {{ sol.region || '—' }} ({{ sol.province || '—' }})
                <br />
                Sede fisica associata: {{ solSiteAddress(sol) }}
              }
            </span>
          </div>
          <div class="sol-detail-item">
            <span class="k">Gerarchia</span>
            <span class="v">{{ hierarchyLabel(sol.hierarchyParentCode, sol.hierarchySuffix) }}</span>
          </div>
          <div class="sol-detail-item sol-detail-item--full">
            <span class="k">Descrizione</span>
            <span class="v">{{ sol.description || '—' }}</span>
          </div>
        </div>
      </section>

      <!-- Blocco 2: dati MFA compilati dal fiduciario -->
      <section class="sol-detail-block sol-detail-block--mfa">
        <h4 class="sol-detail-block__title">
          <i class="pi pi-shield" aria-hidden="true"></i>
          Dati MFA — compilati dal fiduciario
        </h4>
        <div class="sol-detail-grid">
          <div class="sol-detail-item">
            <span class="k">Mail principale</span>
            <span class="v">{{ sol.principalEmail || 'Non ancora compilato' }}</span>
          </div>
          <div class="sol-detail-item">
            <span class="k">Responsabile mail principale</span>
            <span class="v">
              @if (sol.principalHolderLastName || sol.principalHolderFirstName) {
                {{ (sol.principalHolderLastName || '') + ' ' + (sol.principalHolderFirstName || '') }}
                @if (sol.principalHolderFiscalCode) {
                  <span class="text-color-secondary">({{ sol.principalHolderFiscalCode }})</span>
                }
              } @else {
                Non ancora compilato
              }
            </span>
          </div>
        </div>

        <!-- Impiegati amministrativi / collaboratori associati -->
        <div class="sol-detail-assoc">
          <h5 class="sol-detail-assoc__title">
            Impiegati amministrativi e collaboratori associati ({{ selectedAssociations().length }})
          </h5>
          @if (selectedAssociations().length === 0) {
            <p class="sol-detail-assoc__empty">Nessuna associazione presente.</p>
          } @else {
            <div class="sol-detail-assoc__list">
              @for (assoc of selectedAssociations(); track assoc.id) {
                <div class="assoc-card">
                  <div class="assoc-card__person">
                    <span class="assoc-card__avatar" aria-hidden="true"><i class="pi pi-user"></i></span>
                    <div>
                      <div class="assoc-card__name">{{ assoc.lastName }} {{ assoc.firstName }}</div>
                      <div class="assoc-card__meta">
                        <p-tag [value]="associationKindLabel(assoc)" severity="secondary" />
                        @if (associationRole(assoc)) {
                          <span class="assoc-card__role">{{ associationRole(assoc) }}</span>
                        }
                      </div>
                    </div>
                  </div>
                  <div class="assoc-card__mail">
                    <span class="k">Mail sistemi gestionali AXA</span>
                    <span class="v">{{ assoc.accessEmail || '—' }}</span>
                  </div>
                </div>
              }
            </div>
          }
        </div>
      </section>
    </div>
  }
  <ng-template pTemplate="footer">
    <button pButton type="button" label="Annulla" class="p-button-outlined mr-auto" (click)="showDetailDialog.set(false)"></button>
    @if (selectedSol(); as sol) {
      @if (canReactivate(sol)) {
        <button pButton type="button" label="Riattiva" icon="pi pi-play"
          class="p-button-success p-button-outlined" (click)="reactivateSol(sol)"></button>
      }
      @if (canSuspend(sol)) {
        <button pButton type="button" label="Sospendi" icon="pi pi-pause"
          class="p-button-warning p-button-outlined" (click)="suspendSol(sol)"></button>
      }
      @if (canDeactivate(sol)) {
        <button pButton type="button" label="Disattiva" icon="pi pi-ban"
          class="p-button-danger p-button-outlined" (click)="deactivateSol(sol)"></button>
      }
      @if (canEditNow() && sol.status !== 'INACTIVE') {
        <button pButton type="button" label="Modifica" icon="pi pi-pencil" (click)="openEdit(sol)"></button>
      }
    }
  </ng-template>
</p-dialog>

